// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recommendation-chip{border-radius:15px;display:inline-flex;flex-direction:column;min-height:147px;padding:15px;width:147px}.recommendation-chip:hover{cursor:pointer}.recommendation-chip img{height:36px;width:36px}.recommendation-chip span{color:#1a1a1a;font-size:16px;font-weight:500;line-height:120%;margin-top:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
